export const USER_CRUD = {
  saved: 'Usuario creado satisfactoriamente',
  updated: 'Usuario actualizado satisfactoriamente',
};

export const ERROR_MESSAGES = {
  notUser: 'Hubo un error al consultar el usuario',
};

export const SAVE_USER_ERROR_MESSAGES = {
  cost_centre_not_found:
    'No se encontró la cuenta que estás intentando asociar al usuario',
  card_not_found: 'No se encontró la tarjeta que estás intentando asociar al usuario',
  user_exist: 'Ya existe un usuario con ese codigo de usuario',
};
